import { getSubgroupsFromDayDate } from '../getSubgroupsFromDayDate';

import { checkIsStringedDatesListValid, formatDate, WeekParity } from '.';

export const isNeedToShowByWeekParityAndDateTime = ({
  weekParity,
  dayDate,
  searchingDate,
}: {
  weekParity: WeekParity;
  dayDate: string;
  searchingDate?: Date;
}): boolean => {
  const evenName = 'чет';
  const oddName = 'неч';
  const formattedDayDate = dayDate.trim().toLowerCase();

  if (formattedDayDate === '') {
    return true;
  }

  if (formattedDayDate === evenName) {
    return weekParity === WeekParity.Even;
  } else if (formattedDayDate === oddName) {
    return weekParity === WeekParity.Odd;
  }

  if (
    formattedDayDate.includes(evenName) ||
    formattedDayDate.includes(oddName)
  ) {
    if (formattedDayDate === 'чет/неч') {
      return true;
    } else if (formattedDayDate === 'неч/чет') {
      return true;
    } else if (formattedDayDate === 'чет/') {
      return weekParity === WeekParity.Even;
    } else if (formattedDayDate === 'неч/') {
      return weekParity === WeekParity.Odd;
    } else if (formattedDayDate === '/чет') {
      return weekParity === WeekParity.Even;
    } else if (formattedDayDate === '/неч') {
      return weekParity === WeekParity.Odd;
    }

    if (
      (formattedDayDate.includes(evenName) && weekParity === WeekParity.Even) ||
      (formattedDayDate.includes(oddName) && weekParity === WeekParity.Odd)
    ) {
      return true;
    }
    if (
      (formattedDayDate.includes(evenName) && weekParity === WeekParity.Odd) ||
      (formattedDayDate.includes(oddName) && weekParity === WeekParity.Even)
    ) {
      return false;
    }
  }

  if (searchingDate) {
    const date1 = formatDate(searchingDate, 'dd.MM');
    const date2 = formatDate(searchingDate, 'd.MM');

    if (dayDate.includes('/')) {
      const subgroups = getSubgroupsFromDayDate(dayDate);
      if (subgroups.length === 2) {
        const [subgroup1, subgroup2] = subgroups;
        // Проверяем обе подгруппы отдельно
        const inFirstSubgroup = subgroup1.some(
          (d) => d === date1 || d === date2,
        );
        const inSecondSubgroup = subgroup2.some(
          (d) => d === date1 || d === date2,
        );

        // Если дата есть в любой из подгрупп - показываем
        return inFirstSubgroup || inSecondSubgroup;
      } else if (subgroups.length === 1) {
        // Обработка случаев типа "даты/"
        return subgroups[0].some((d) => d === date1 || d === date2);
      }
    } else {
      // Обработка случаев без разделителя подгрупп
      const dates = formattedDayDate.split(' ').filter(Boolean);
      if (checkIsStringedDatesListValid(dates)) {
        return dates.some((d) => d === date1 || d === date2);
      }
    }
  }

  // По умолчанию показываем, если не нашли причин скрыть
  return true;
};
